import { Browser } from '@capacitor/browser'

import { isNativePlatform } from './platform'

export async function openExternalUrl(url: string): Promise<void> {
  if (!url) return
  if (isNativePlatform()) {
    await Browser.open({ url, presentationStyle: 'popover' })
    return
  }
  window.open(url, '_blank', 'noopener,noreferrer')
}

export function interceptExternalLinks(): () => void {
  if (!isNativePlatform() || typeof document === 'undefined') return () => undefined

  const onClick = (event: MouseEvent) => {
    const target = event.target
    if (!(target instanceof Element)) return
    const anchor = target.closest('a')
    if (!anchor) return
    const href = anchor.getAttribute('href')
    if (!href || href.startsWith('/') || href.startsWith('#') || href.startsWith('mailto:')) return
    const isBlank = anchor.getAttribute('target') === '_blank'
    const isHttp = href.startsWith('http://') || href.startsWith('https://')
    if (!isBlank && !isHttp) return
    if (!isHttp) return
    event.preventDefault()
    void openExternalUrl(href)
  }

  document.addEventListener('click', onClick)
  return () => document.removeEventListener('click', onClick)
}
